import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import cx from "classnames";
import { useEffect, useRef } from "react";
import CaramelImg from "./assets/caramel.jpg";
import Carat from "./assets/carat.svg";
import ChocolateImg from "./assets/choc.jpg";
import PBImg from "./assets/chocpb.jpg";
import CinnImg from "./assets/cinn.jpg";
import CNCImg from "./assets/cnc.jpg";
import Minus from "./assets/minus.svg";
import MochaImg from "./assets/mocha.jpg";
import Plus from "./assets/plus.svg";
import StrawberryImg from "./assets/strawberry.jpg";
import VanillaImg from "./assets/vanilla.jpg";
import VarietyImg from "./assets/variety.jpg";
import styles from "./styles.module.scss";
const FlavorItem = ({ sku, name, image, quantity, adjustQuantity, }) => {
    return (_jsxs("div", { className: styles.itemWrapper, children: [_jsxs("div", { className: styles.left, children: [_jsx("img", { src: image, alt: "flavor stick", className: styles.flavorImg }), _jsx("div", { children: name })] }), _jsxs("div", { className: styles.quantityControl, children: [!!quantity && (_jsxs(_Fragment, { children: [_jsx("button", { className: cx(styles.qtyButton, styles.minus), onClick: () => adjustQuantity(sku, "decrement"), children: _jsx("img", { src: Minus, alt: "Minus" }) }), _jsx("div", { className: styles.quantity, children: quantity })] })), _jsx("button", { className: cx(styles.qtyButton, styles.plus), onClick: () => adjustQuantity(sku, "increment"), children: _jsx("img", { src: Plus, alt: "Plus" }) })] })] }));
};
export const data = [
    { sku: "variety", image: VarietyImg, name: "Variety Pack" },
    { sku: "caramel", image: CaramelImg, name: "Sea Salt Caramel" },
    { sku: "chocolate", image: ChocolateImg, name: "Rich Chocolate" },
    { sku: "cinnamon", image: CinnImg, name: "Cinnamon Toast" },
    { sku: "cookies", image: CNCImg, name: "Cookies & Cream" },
    { sku: "mocha", image: MochaImg, name: "Caffè Mocha" },
    { sku: "peanut", image: PBImg, name: "Chocolate Peanut Butter" },
    { sku: "strawberry", image: StrawberryImg, name: "Strawberry Cream" },
    { sku: "vanilla", image: VanillaImg, name: "Madagascar Vanilla" },
];
const FlavorPicker = ({ updateValues, values, maxItems = 2, text, isOpen, setIsOpen, }) => {
    const sumSelected = Object.values(values).reduce((acc, val) => acc + val, 0);
    const dropdownRef = useRef(null);
    useEffect(() => {
        const handleClickOutside = (event) => {
            event.preventDefault();
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [dropdownRef]);
    return (_jsxs("div", { className: styles.wrapper, ref: dropdownRef, children: [_jsxs("div", { className: styles.selectBox, onClick: (e) => {
                    e.preventDefault();
                    setIsOpen(!isOpen);
                }, children: [_jsx("div", { children: text || "—Select—" }), _jsx("button", { className: styles.dropdownButton, onClick: (e) => {
                            e.preventDefault();
                            setIsOpen(!isOpen);
                        }, children: _jsx("img", { src: Carat, alt: "Dropdown icon", className: cx(styles.carat, {
                                [styles.caratPointingDown]: !isOpen,
                            }) }) })] }), isOpen && (_jsx("div", { className: styles.dropdown, children: data.map((flavor) => {
                    return (_jsx(FlavorItem, { sku: flavor.sku, name: flavor.name, image: flavor.image, adjustQuantity: updateValues, quantity: values[flavor.sku] || 0 }, flavor.sku));
                }) }))] }));
};
export default FlavorPicker;
